import React from 'react';
import { useParams } from 'react-router-dom';
import CustomerLayout from '../../components/CustomerLayout';
import Receipt from '../../components/Receipt';
import { useApi } from '../../lib/api';
import { useAuth } from '../../context/AuthContext';
import { ReceiptText } from 'lucide-react';
import { CustomerPageHeading } from '../../components/customer/CustomerPageHeading';

export default function CustomerReceiptPage() {
  const { id } = useParams();
  const { user } = useAuth();
  const { data: tx, loading, error } = useApi(`/portal/transactions/${id}`);
  if (loading) return <CustomerLayout><div data-testid="customer-receipt-loading" role="status" className="customer-empty">Loading receipt…</div></CustomerLayout>;
  if (error || !tx) return <CustomerLayout><div data-testid="customer-receipt-error" role="alert" className="customer-alert">{error || 'Not found'}</div></CustomerLayout>;
  return <CustomerLayout><CustomerPageHeading title="Transaction receipt" icon={ReceiptText} testId="customer-receipt-heading" /><Receipt tx={tx} shopName={user?.shopName} compact /></CustomerLayout>;
}
